/*
 * @Author: Src
 * @Date: 2025-05-14 18:17:43
 * @LastEditTime: 2025-05-14 18:32:20
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/services/privacy.service.ts
 * @Description: 头部注释配置模板
 */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class PrivacyService {
    @inject(HttpClient)
    protected http!: HttpClient;

    async getAuthInfo(params: any) {
        try {
            const result = await this.http.get('auth-phone/auth_info', {params});
            return result;
        } catch (error) {
            return null;
        }
    }
    


    async editAuth(params: any) {
        try {
            const result = await this.http.post('auth-phone/edit_auth', params);
            return result;
        } catch (error) {
            return null;
        }
    }
}